<template>
  <div class="checklist-block-iqos-footer common-block-settings">
    <div
      class="iqos-tooltip-helper-box"
      @mouseenter="requiredHover = true"
      @mouseleave="requiredHover = false"
    >
      <IQOSTooltip
        :backdrop="false"
        :earPosition="'bottom'"
        v-show="requiredHover"
      >
        {{ $t('checklist_blocks.settings.required_desc') }}
      </IQOSTooltip>
     <BaseBetaCheckbox :value="block.required" @input="v => {block.required = v; $emit('update')}">
        {{ $t('checklist_blocks.settings.required') }}
      </BaseBetaCheckbox>
    </div>

    <!-- <BaseBetaCheckbox v-model="block.restricted"> Restricted </BaseBetaCheckbox>
    -->
    <BaseBetaCheckbox :value="block.cached" @input="v => {block.cached = v; $emit('update')}">
      {{ $t('checklist_blocks.settings.cached') }}
    </BaseBetaCheckbox> 

    <div
      class="iqos-tooltip-helper-box"
      @mouseenter="scoresHover = true"
      @mouseleave="scoresHover = false"
    >
      <IQOSTooltip
        :backdrop="false"
        :earPosition="'bottom'"
        v-show="scoresHover"
      >
        {{ $t('checklist_blocks.settings.scores_desc')}}
      </IQOSTooltip>
      <BaseBetaCheckbox
      v-model="block.options.scored"
      v-if="block.type === 'OPTIONS'"
    >
      {{ $t('checklist_blocks.settings.scores') }}
    </BaseBetaCheckbox>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    block: Object,
  },
  data() {
    return {
      requiredHover: false,
      scoresHover: false
    };
  },
};
</script>

<style scoped>
.common-block-settings {
  border-radius: 0 0 8px 8px;
  column-gap: 24px;
}
</style>